
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TabTrappedArea extends Vue {
  @Prop() firstItemId!: string;
  @Prop() lastItemId!: string;
  @Prop({ default: false }) trapClick!: boolean;
  @Prop({ default: false }) disabled!: boolean;

  public $refs!: {
    clickTrap: HTMLElement;
    trapEntry: HTMLElement;
  };
  mounted() {
    this.shieldUp(true);
  }
  beforeDestroy() {
    this.shieldUp(false);
  }
  handleTrapBegin() {
    this.shieldUp(true);
    this.enterPortal(this.lastItemId);
  }
  handleTrapEnd() {
    this.shieldUp(true);
    this.enterPortal(this.firstItemId);
  }
  shieldUp(shieldUp : boolean = false){
    let shield : HTMLElement | null = document.querySelector('.click-shield');
    if (shield && this.trapClick)
      shield.style.display = shieldUp ? 'block' : 'none';
  }
  enterPortal(targetId: string) {
    let target = document.getElementById(targetId);
    if (target) 
      target.focus();
  }
}
